import styled from "styled-components";
import colors from "../../../../../../../config/colors";
import { Scrollable, panelSpacing } from "../../../../../../../common/styles";

export const ConnectionProfileContainer = styled.div`
  overflow-y: auto;
  height: calc(100vh - 150px);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  margin: 0 12px;
  ${Scrollable};
  @media (max-width: 767px) {
    height: calc(100vh - 160px);
  }
`;
export const ConnectionProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 25px 35px;
  border-bottom: ${(props) =>
    props.isConnection ? "0" : `1px solid ${colors.secondary}`};
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;
export const BackButton = styled.div`
  @media (max-width: 767px) {
    margin-right: auto;
  }
`;
export const ProfileImage = styled.img`
  height: 65px;
  width: 65px;
  aspect-ratio: 1 / 1;
  object-position: top;
  border-radius: 50%;
  object-fit: cover;
`;
export const ProfileInfo = styled.div``;
export const ProfileHeader = styled.div``;
export const ProfileName = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const ProfileDescription = styled.div`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4px;
`;
export const ProfileActions = styled.div`
  margin-top: 16px;
  display: flex;
  svg {
    width: 16px;
    height: 16px;
  }
`;
export const PillsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  width: 100%;
`;

export const ProfileInfoContainer = styled.div`
  display: flex;
  gap: 16px;
`;
